inputs-without-label-typeahead-single
  .text-wrap(if="{ opts.text != '' }")
    .text.align-middle { opts.text }
    .remove-wrap
      span.align-middle.btn.btn-sm.btn-danger.btn-outline-danger.icon-btn.btn-close(if="{ opts.text != '' }" onClick="{this.onClickRemoveBtn}")
        i.feather.icon-x
  input(type="hidden" name="{opts.name}" value="{opts.value}")
  inputs-without-label-typeahead(if="{ opts.text == '' }" tag-scope="{ this.tagScope }.typeahead" onSelect="{ this.onSelectItem }")
  div.help-block(if="{ opts.errors }")
    ul(role="alert")
      li.text-danger.error(each="{message in opts.errors}") { message }
  script(type="typescript").
    this.mixin('inputs.typeahead-single');
  style(scoped).
    :scope {
      display: block;
    }
    .text {
      display: inline-block;
      padding-top: calc(0.375rem + 1px);
      padding-bottom: calc(0.375rem + 1px);
      flex-grow: 5;
    }
    .text-wrap {
      display: flex;
    }
    .remove-wrap {
      width: 41px;
    }
    
